import i18next from 'i18next'
import { z } from 'zod'

import { matchTypeValues } from 'features/inventory/page/types/matchType'
import { adUnitIdsField } from './adUnitIdsField'

export const commonSchema = z
  .object({
    customVariableName: z.string(),
    customVariableTriggerEnabled: z.boolean(),
    customVariableValue: z.string(),
    domainId: z.string().nonempty(i18next.t('common:form.error.nonEmpty')),
    matchType: z.enum(matchTypeValues),
    name: z.string().nonempty(),
    onlySendAdRequestsForAssignedAdUnits: z.boolean(),
    path: z.string(),
    pathTriggerEnabled: z.boolean(),
  })
  .extend(adUnitIdsField.shape)

export type CommonSchema = z.infer<typeof commonSchema>
